import classNames from 'classnames';
import './SettlementSectionPanel.css';

interface Props {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

export const SettlementEmailTmpSection = ({ title, children, className }: Props) => {
  return (
    <div className="settlement-email-template-section">
      <div className="settlement-email-template-section__title"> {title} </div>
      <div
        className={classNames('settlement-email-template-section__body', className)}
      >
        {children}
      </div>
    </div>
  );
};
